namespace GeniuzPOS.PosShift {
    export interface LookupPostranhdsaleRow {
        Id?: number;
        DocNo?: string;
        DocDate?: string;
        DocTime?: string;
        RefDocNo?: string;
        PosId?: string;
        CashierId?: string;
        MbId?: string;
        SalesmanId?: string;
        SalesVatType?: string;
        Factor?: number;
        ShopId?: string;
    }

    export namespace LookupPostranhdsaleRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.LookupPostranhdsale';
        export const lookupKey = 'LookupPostranhdsaleRow';

        export function getLookup(): Q.Lookup<LookupPostranhdsaleRow> {
            return Q.getLookup<LookupPostranhdsaleRow>('LookupPostranhdsaleRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            DocDate = "DocDate",
            DocTime = "DocTime",
            RefDocNo = "RefDocNo",
            PosId = "PosId",
            CashierId = "CashierId",
            MbId = "MbId",
            SalesmanId = "SalesmanId",
            SalesVatType = "SalesVatType",
            Factor = "Factor",
            ShopId = "ShopId"
        }
    }
}
